if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector !== this;
      });

      this.productWrapper = this.closest('.thb-product-detail');

      if (this.productWrapper) {
        this.productSlider =
          this.productWrapper.querySelector('.product-images') ||
          this.productWrapper.querySelector('.product-quick-images') ||
          this.productWrapper.querySelector('[data-product-slider]') ||
          this.productWrapper.querySelector('product-media-gallery-wub') ||
          null;

        this.thumbnails =
          this.productWrapper.querySelector('.product-thumbnail-container') ||
          this.productWrapper.querySelector('[data-product-thumbnails]') ||
          this.productWrapper.querySelector('.wub-media-gallery__thumbs') ||
          null;

        this.hideVariants =
          this.productSlider &&
          this.productSlider.dataset &&
          this.productSlider.dataset.hideVariants === 'true';
      } else {
        this.productSlider = null;
        this.thumbnails = null;
        this.hideVariants = false;
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();

      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];

      this.fieldsets.forEach((fieldset) => {
        const select = fieldset.querySelector('select');
        const checkedInput = fieldset.querySelector('input:checked');
        const firstInput = fieldset.querySelector('input');

        if (select) {
          this.options.push(select.value);
          this.option_keys.push(select.name);
        } else if (checkedInput && firstInput) {
          this.options.push(checkedInput.value);
          this.option_keys.push(firstInput.name);
        }
      });

      this.dataset.options = this.options;
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        const label = item.querySelector('.form__label__value');
        if (label && typeof this.options[i] !== 'undefined') {
          label.innerHTML = this.options[i];
        }
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }

      if (this.other.length) {
        const otherSelector = this.other[0];
        const fieldsets = otherSelector.querySelectorAll('fieldset');
        const fieldsetsArray = Array.from(fieldsets);

        this.options.forEach((option, i) => {
          const targetFieldset = fieldsetsArray[i];
          if (!targetFieldset) return;

          const select = targetFieldset.querySelector('select');
          const radio = targetFieldset.querySelector(`input[value="${CSS.escape(option)}"]`);

          if (select) {
            select.value = option;
          } else if (radio) {
            radio.checked = true;
          }
        });

        otherSelector.updateOptions();
        otherSelector.updateMasterId();
        otherSelector.updateVariantText();
        otherSelector.setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;

      const mediaId = String(this.currentVariant.featured_media.id);

      if (this.productSlider.matches && this.productSlider.matches('product-media-gallery-wub')) {
        if (typeof this.productSlider.activateByMediaId === 'function') {
          this.productSlider.activateByMediaId(mediaId, false);
        }
        return;
      }

      const legacyMediaId = `#Slide-${this.dataset.section}-${mediaId}`;
      const activeMedia = this.productSlider.querySelector(legacyMediaId);

      if (!activeMedia) return;

      if (this.thumbnails) {
        this.setActiveMediaSlider(
          legacyMediaId,
          `#Thumb-${this.dataset.section}-${mediaId}`,
          this.productSlider
        );
      } else {
        this.setActiveMedia(activeMedia);
      }
    }

    setActiveMedia(activeMedia) {
      if (!this.productSlider || !activeMedia) return;

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      if (activeMedia.parentElement) {
        activeMedia.parentElement.prepend(activeMedia);
      }

      if (!this.sticky) {
        window.setTimeout(() => {
          if (!activeMedia.parentElement) return;

          if (window.innerWidth > 1068) {
            const headerHeight = parseInt(
              getComputedStyle(document.documentElement).getPropertyValue('--header-height')
            ) || 0;

            const headerOffset = activeMedia.parentElement.offsetTop - headerHeight;
            const scrollObj = {
              left: 0,
              behavior: 'instant'
            };

            if (headerOffset > 0) {
              scrollObj.top = headerOffset;
            }

            window.scrollTo(scrollObj);
          }

          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }

    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      if (!productSlider) return;

      const flkty = productSlider.flkty;
      const activeMedia = productSlider.querySelector(mediaId);

      if (!activeMedia) return;

      if (flkty && this.hideVariants) {
        const initialSelected = productSlider.querySelector('.product-images__slide.is-initial-selected');
        if (initialSelected) {
          initialSelected.classList.remove('is-initial-selected');
        }

        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function(el) {
          el.classList.remove('is-active');
        });

        if (this.thumbnails) {
          const initialThumb = this.thumbnails.querySelector('.product-thumbnail.is-initial-selected');
          if (initialThumb) {
            initialThumb.classList.remove('is-initial-selected');
          }

          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function(el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          const activeThumb = this.thumbnails.querySelector(thumbId);
          if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }
        }

        if (typeof productSlider.reInit === 'function') {
          productSlider.reInit(this.imageSetIndex);
        }

        if (typeof productSlider.selectCell === 'function') {
          productSlider.selectCell(mediaId);
        }

      } else if (flkty && typeof productSlider.selectCell === 'function') {
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || typeof shareButton.updateUrl !== 'function') return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);

      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input || !this.currentVariant) return;

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available && typeof pickUpAvailability.fetchAvailability === 'function') {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage();
      }
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`
      ];
    }

    renderProductInfo() {
      const sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }

            const price = document.getElementById(id);
            const priceFixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (priceFixed) priceFixed.classList.remove('visibility-hidden');
          });

          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const formWrapper = productForm.closest('.product-form');
      const productTemplate = formWrapper ? formWrapper.getAttribute('template') : '';
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons.length) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate && productTemplate.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const priceFixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton || !submitButtonText) return;

        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });

      if (price) price.classList.add('visibility-hidden');
      if (priceFixed) priceFixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature !== 'true') {
        return;
      }

      const variantData = this.getVariantData();
      if (!variantData) return true;

      let selectedOptions = false;

      if (this.currentVariant) {
        selectedOptions = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
      } else {
        const foundOption = variantData.find((option) => {
          return option.option1 === this.options[0];
        });

        if (foundOption) {
          selectedOptions = [
            {
              value: this.options[0],
              index: 'option1'
            },
            {
              value: foundOption.option2,
              index: 'option2'
            }
          ];
        } else {
          return true;
        }
      }

      const availableOptions = this.createAvailableOptionsTree(variantData, selectedOptions);

      this.fieldsets.forEach((fieldset, i) => {
        const fieldsetOptions = Object.values(availableOptions)[i];
        if (!fieldsetOptions) return;

        const select = fieldset.querySelector('select');
        const inputs = fieldset.querySelectorAll('input');

        if (select) {
          fieldsetOptions.forEach((option) => {
            const targetOption = fieldset.querySelector(`option[value=${JSON.stringify(option.value)}]`);
            if (!targetOption) return;
            targetOption.disabled = !!option.isUnavailable;
          });
        } else if (inputs.length) {
          inputs.forEach((input, inputIndex) => {
            if (!fieldsetOptions[inputIndex]) return;
            input.classList.toggle('is-disabled', fieldsetOptions[inputIndex].isUnavailable);
          });
        }
      });

      return true;
    }

    getImageSetName(variantName) {
      if (!variantName) return '';
      return variantName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      const dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (!dataSetEl) return;

      this.imageSetName = dataSetEl.dataset.setName;

      const inputWithHandle = this.querySelector(`.product-form__input[data-handle="${this.imageSetName}"]`);
      if (!inputWithHandle || !inputWithHandle.dataset) return;

      this.imageSetIndex = inputWithHandle.dataset.index;
      this.dataset.imageSetIndex = this.imageSetIndex;
      this.setImageSetMedia();
    }

    setImageSetMedia() {
      if (!this.imageSetIndex || !this.currentVariant || !this.productSlider) {
        return;
      }

      const variantValue = this.currentVariant[this.imageSetIndex];
      if (!variantValue) return;

      const setValue = this.getImageSetName(variantValue);
      const group = this.imageSetName + '_' + setValue;

      const selectedSetImages = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`);
      const selectedSetThumbs = this.productWrapper
        ? this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`)
        : [];

      if (this.hideVariants) {
        if (this.thumbnails) {
          this.productWrapper.querySelectorAll('.product-images__slide').forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });

          selectedSetImages.forEach((thumb) => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          this.productWrapper.querySelectorAll('.product-thumbnail').forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });

          selectedSetThumbs.forEach((thumb) => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          this.productWrapper.querySelectorAll('.product-images__slide').forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });

          selectedSetImages.forEach((thumb) => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        }
      } else {
        if (!this.thumbnails) {
          const setImages = Array.from(selectedSetImages).filter(function(element) {
            return element.dataset.group === group;
          });

          setImages.forEach((thumb) => {
            if (thumb.parentElement) {
              thumb.parentElement.prepend(thumb);
            }
          });
        }
      }

      if (!this.thumbnails && this.productSlider && typeof this.productSlider.onPaginationResize === 'function') {
        setTimeout(() => {
          this.productSlider.onPaginationResize();
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      return variants.reduce((options, variant) => {
        Object.keys(options).forEach((index) => {
          if (variant[index] === null) return;

          let entry = options[index].find((option) => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              if (
                currentOption1 &&
                variant.option1 === currentOption1.value &&
                currentOption2 &&
                variant.option2 === currentOption2.value
              ) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      if (!this.variantData) {
        const jsonEl = this.querySelector('[type="application/json"]');
        this.variantData = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      }
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        return checked ? checked.value : '';
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.pagination = this.parentElement ? this.parentElement.querySelector('.product-images-buttons') : null;
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      const observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(() => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }

    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }

    buildItems(activeImages) {
      return activeImages.map((item) => {
        const activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
    }

    setEventListeners() {
      const activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter((element) => element.clientWidth > 0);
      const items = this.buildItems(activeImages);
      const captionEl = this.dataset.captions;
      const pswpElement = document.querySelectorAll('.pswp')[0];

      const options = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: captionEl,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true
      };

      const openPswp = function(e, link, options, pswpElement, items) {
        const parent = link.closest('.product-images__slide');
        const i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);

        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media');
          const pageYScroll = window.scrollY || document.documentElement.scrollTop;
          const rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };

        if (typeof PhotoSwipe !== 'undefined') {
          const pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function(item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });

          pswp.init();
        }

        e.preventDefault();
      };

      this.querySelectorAll('.product-single__media-zoom').forEach(function(link) {
        const thumbnail = link.closest('.product-single__media');
        if (!thumbnail) return;

        const clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();

        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        const button = container.querySelector('button');
        if (!button) return;

        button.addEventListener('click', function() {
          container.setAttribute('hidden', '');
        });
      });
    }

    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      if (!this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }

    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }

    onPaginationButtonClick(event) {
      event.preventDefault();

      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.scrollLeft + (1 * this.sliderItemOffset)
          : this.scrollLeft - (1 * this.sliderItemOffset);

      this.scrollTo({
        left: this.slideScrollPosition
      });
    }

    updatePagination() {
      if (!this.nextButton || !this.prevButton || !this.sliderItemsToShow || !this.sliderItemsToShow.length) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }

      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage !== previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }

  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) return;

      const idInput = this.form.querySelector('[name=id]');
      if (idInput) {
        idInput.disabled = false;
      }

      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form || !this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      const formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });

            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }

            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }

        if (!parsedState.sections || !parsedState.sections[section.section]) {
          return;
        }

        const container = document.getElementById(section.id);
        const elementToReplace = container.querySelector(section.selector) || container;
        const html = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (html) {
          elementToReplace.innerHTML = html;
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });

      const productDrawer = document.getElementById('Product-Drawer');
      if (productDrawer && productDrawer.contains(this)) {
        document.body.classList.remove('open-cc--product');
        productDrawer.classList.remove('active');
        productDrawer.setAttribute('inert', '');
      }

      const cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url)
        ? window.theme.routes.cart_url
        : '/cart';

      window.location.href = cartUrl;
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const found = parsed.querySelector(selector);
      return found ? found.innerHTML : '';
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }

    setupObservers() {
      const _this = this;
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const footer = document.getElementById('footer');

      if (!form || !footer) return;

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach((entry) => {
          if (entry.target === footer) {
            if (entry.intersectionRatio > 0) {
              _this.classList.remove('sticky--visible');
            } else if (entry.intersectionRatio === 0 && _this.formPassed) {
              _this.classList.add('sticky--visible');
            }
          }

          if (entry.target === form) {
            const boundingRect = form.getBoundingClientRect();

            if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
              _this.formPassed = true;
              _this.classList.add('sticky--visible');
            } else if (entry.intersectionRatio === 1) {
              _this.formPassed = false;
              _this.classList.remove('sticky--visible');
            }
          }
        });
      }, {
        threshold: [0, 1]
      });

      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== 'undefined') {
  addIdToRecentlyViewed();
}